/* eslint-disable */
import StaticQuestions from '@/data/static-questions';
import axios from 'axios';

const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

let CURRENT_LOCALE = process.env.VUE_APP_I18N_LOCALE;

$axios.interceptors.request.use(function (config) {
  if (config.url && config.url.startsWith('https://static.trouveunavocat.be/')) {
    return config;
  }

  const { method, url } = config;

  if (method === 'get') {
    const hasLangParam = url.includes('lang=');

    if (!hasLangParam) {
      const index = url.indexOf('?');
      config.url = `${url}${index >= 0 ? '&' : '?'}lang=${CURRENT_LOCALE}`;
    }
  }

  return config;
});
// api/casus/formAnswers

const getLawyerQuestion = (lawyers) => {
  return {
    id: 'question-lawyer',
    title: {
      fr: 'A quel avocat voulez-vous envoyer votre demande ?',
      nl: 'Aan welke advocaat wilt u uw verzoek richten?',
      en: 'Which lawyer do you want to send your request?'
    },
    description: { fr: '', en: '', nl: '' },
    type: 'radio',
    value: '',
    answers: lawyers.map(lawyer => {
      return {
        id: `lawyer-${lawyer.id}`,
        value: lawyer.id,
        label: {
          fr: `${lawyer.firstname} ${lawyer.lastname}`,
          nl: `${lawyer.firstname} ${lawyer.lastname}`,
          en: `${lawyer.firstname} ${lawyer.lastname}`
        }
      };
    })
  };
};


const calls = {
  namespaced: 'true',
  mutations: {
    updateCallLocale(state, lang) {
      CURRENT_LOCALE = lang;
    }
  },
  actions: {
    // Done
    async inOrder(context, uuid) {
      try {
        const response = await $axios.get(`casus/clients/${uuid}/in-order`);
        const { status } = response;

        return { status: 'success', data: {
          inOrder: status === 200
        } };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async search(context, { uuid, terms }) {
      try {
        const response = await $axios.post(`casus/clients/${uuid}/search/`, {
          lang: context.rootState.locale,
          term: terms,
          penal: true
        });

        const { data } = response.data;

        return { status: 'success', data };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async lawyer(context, uuid) {
      try {
        const response = await $axios.get(`casus/clients/${uuid}`);
        const { data } = response;
        return { status: 'success', data };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async lawCase(context, id) {
      try {
        const response = await $axios.get(`lawCases/${id}?magic`);
        const { data } = response;
        return { status: 'success', data };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async form(context, { caseID, uuid, lawyers }) {
      try {
        const response = await $axios.get(`casus/clients/${uuid}/${caseID}`);
        const { data, status } = response;
        data.status = status;

        // Store the results if results
        if (data && data.data) {
          if (lawyers) {
            const lawyersQuestion = getLawyerQuestion(lawyers);
            data.data.content.data.push(lawyersQuestion);
          }

          StaticQuestions.map((question) => {
            const q = { ...question };
            data.data.content.data.push(q);
          });

          data.data.content.meta.uuid = data.data.uuid;
        }

        return { status: 'success', data };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async sendFile({ context }, file) {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const { data } = await $axios.post('casus/formAnswers/files/', formData);
        return data;
      } catch (error) {
        throw new Error(error);
      }
    },
    async sendForm({ context }, data) {
      try {
        const response = await $axios.post('casus/formAnswers/', data);
        return { status: 'success', data: response };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async staticPage({ context }, id) {
      try {
        const response = await $axios.get(`https://static.trouveunavocat.be/wp-json/acf/v3/pages/${id}`);
        return { status: 'success', data: response.data };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async getPolicy({ rootState }, type) {
      const { uuid } = rootState.client;
      try {
        const response = await $axios.get(`client/${uuid}/policies`);
        const policies = response.data;
        if (!policies) return { status: 'error', error: 'No policies' };
        if (type) {
          return {
            status: 'success',
            data: {
              data: policies.data[type],
              pdf: policies.pdfs[type]
            }
          }
        }

        return {
          status: 'success',
          data: policies
        };
      } catch (error) {
        return { status: 'error', error };
      }
    },
    async getDataForMagic({ context }, { uuid, lawcaseId }) {
      try {
        const response = await $axios.get(`casus/magic?client_uuid=${uuid}&lawcase_id=${lawcaseId}`);
        const lawyers = response.data.client.mail_system === 2 ? response.data.client.lawyer_list : null;

        if (lawyers) {
          const lawyersQuestion = getLawyerQuestion(lawyers);
          response.data.form.content.data.push(lawyersQuestion);
        }

        StaticQuestions.map((question) => {
          const q = { ...question };
          response.data.form.content.data.push(q);
        });

        response.data.form.content.meta.uuid = response.data.form.uuid;

        return {
          status: 'success',
          data: {
            lawyer: response.data.client,
            lawcase: response.data.lawcase,
            form: response.data.form
          }
        };
      } catch (error) {
        return { status: 'error', error };
      }
    }
  }
}

export default calls;
